module.exports = __webpack_public_path__ + "img/chest2_open.ab9e34d1.png";